export const { warn } = console;

export const OUT_OF_SCOPE =
    'method can only be used inside setup() or functional components';
